/**
 * @generated SignedSource<<1fba2fbdad7562d5e5b84d429f2952ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineType = "DEFAULT" | "EVENT_ITEM" | "KPI" | "STANDARD" | "TEMPLATE";
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskSingleSettingsScreenComponent_task$data = {
  readonly activeSectionVersions: ReadonlyArray<{
    readonly id: string;
    readonly section: {
      readonly id: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"RoutineSectionListItem_RoutineSectionVersion">;
  }>;
  readonly id: string;
  readonly routine: {
    readonly type: RoutineType;
  };
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingleSettingsScreenComponentTask_task">;
  readonly " $fragmentType": "WidgetTaskSingleSettingsScreenComponent_task";
};
export type WidgetTaskSingleSettingsScreenComponent_task$key = {
  readonly " $data"?: WidgetTaskSingleSettingsScreenComponent_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingleSettingsScreenComponent_task">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTaskSingleSettingsScreenComponent_task",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routine",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTaskSingleSettingsScreenComponentTask_task"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSectionVersion",
      "kind": "LinkedField",
      "name": "activeSectionVersions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSection",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RoutineSectionListItem_RoutineSectionVersion"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": "__isTask"
};
})();

(node as any).hash = "ab3c8b30d8528bdc9b6efa3a69320b3a";

export default node;
